import HREmployees from "../hr/HREmployees";
import HRManagement from "../hr/HRManagement";

const hrRoutes = [
  { path: "/hr/employees", component: HREmployees },
  { path: "/hr/management", component: HRManagement },
];

export default hrRoutes;
